module.exports = __webpack_public_path__ + "img/banner.27f0f363.jpg";